import './Button.scss';

import BaseButton from '../../../../../../../../components/Button/Button';

export default function Button({ text, loading, onClick }) {
  return <BaseButton className="CountdownButton" text={text} loading={loading} onClick={onClick} />;
}
